import { CAPTCHA_TOKEN_HEADER } from 'helpers/captcha/contracts'
import type {
  CaptchaProof,
  CaptchaRequestHeaders,
} from 'helpers/captcha/contracts'

export function captchaProofHeaders(
  proof: CaptchaProof,
): CaptchaRequestHeaders {
  return { [CAPTCHA_TOKEN_HEADER]: proof.token }
}
